import React from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';
import {
  Wrapper,
  ImageContainer,
  TextContainer,
  Title,
  Text,
  Actions,
  StyledLink,
} from './NoData.styles';

const INDUSTRY_SETTINGS = '/settings/benchmarks';

export const NoData = () => {
  return (
    <Wrapper>
      <ImageContainer />
      <TextContainer>
        <Title>Industry not defined</Title>
        <Text>
          Please define an industry or blend of industries in order to use the
          benchmarking module
        </Text>
        <Actions>
          <StyledLink to={INDUSTRY_SETTINGS}>
            <ApButtonMain iconName="outline_settings">
              Define industry
            </ApButtonMain>
          </StyledLink>
        </Actions>
      </TextContainer>
    </Wrapper>
  );
};
